<div class="w-dialog h-screen flex flex-col">
  <div class="flex justify-between items-center p-5 bg-color-primary-standard text-white">
    <div data-test-id="dialog-title">
      @if (!isOnEditDialog() && hasCanEditPermission) {
        {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.NEW' | translate }}
      }
      @if (isOnEditDialog() && pendency?.status !== 'done' && hasCanEditPermission) {
        {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.UPDATE' | translate }}
      }
      @if ((isOnEditDialog() && pendency?.status === 'done') || !hasCanEditPermission) {
        {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.VIEW' | translate }}
      }
    </div>
    <mat-icon
      [ngClass]="{ 'cursor-default pointer-events-none opacity-50': isLoading() }"
      (click)="closeDialog()"
      class="mat-24 cursor-pointer hover:opacity-80"
      mat-dialog-close
      >close</mat-icon
    >
  </div>

  @if ((pendency?.status === 'done' || !hasCanEditPermission) && showInfo()) {
    <div class="flex items-center overflow-hidden box-border justify-between w-full bg-color-warning-light p-6">
      <div class="flex gap-3 w-full">
        <mat-icon class="flex items-center justify-center text-xl w-5 h-5 min-w-[20px] min-h-[20px] text-color-primary"
          >error</mat-icon
        >
        <span class="text-sm font-normal text-color-normal tracking-[0.14px]">
          @if (pendency?.status === 'done' && hasCanEditPermission) {
            {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.INFO.DONE' | translate }}
          }
          @if (!hasCanEditPermission) {
            {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.INFO.NO_PERMISSION' | translate }}
          }
        </span>
      </div>
      <mat-icon
        (click)="showInfo.set(false)"
        class="flex items-center justify-center cursor-pointer text-xl w-5 h-5 min-w-[20px] min-h-[20px] text-color-primary"
        >close</mat-icon
      >
    </div>
  }

  <ng-scrollbar [visibility]="'hover'">
    <form [formGroup]="pendencyForm" class="flex flex-col gap-4 justify-start py-6 px-[25px] h-full">
      <div class="flex flex-col gap-3">
        <span data-test-id="pendency-title-instructions" class="text-color-secondary text-sm mb-3"
          >1. {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.TITLE.DESCRIPTION' | translate }}</span
        >

        <mat-form-field appearance="outline">
          <mat-label>{{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.TITLE.LABEL' | translate }}</mat-label>
          <input matInput #titleInput formControlName="title" data-test-id="pendency-title" required />
          <mat-hint align="end" class="text-xs text-color-secondary">({{ titleInput.value.length }}/{{ nameMaxLength }})</mat-hint>
          @if (pendencyForm.get('title')?.hasError('required')) {
            <mat-error>
              {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.ERROR.REQUIRED' | translate }}
            </mat-error>
          }
          @if (pendencyForm.get('title')?.hasError('maxlength')) {
            <mat-error>
              {{
                'CREATE_OR_EDIT_PENDENCY_DIALOG.ERROR.MAX_LENGTH'
                  | translate: { maxLength: nameMaxLength, length: titleInput.value.length }
              }}
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.DESCRIPTION' | translate }}</mat-label>
          <textarea
            matInput
            #descriptionInput
            cdkTextareaAutosize
            rows="2"
            #autosize="cdkTextareaAutosize"
            formControlName="description"
            data-test-id="pendency-description"
          ></textarea>
          <mat-hint align="end" class="text-xs text-color-secondary">
            ({{ descriptionInput.value.length }}/{{ descriptionMaxLength }})
          </mat-hint>
          @if (pendencyForm.get('description')?.hasError('required')) {
            <mat-error>
              {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.ERROR.REQUIRED' | translate }}
            </mat-error>
          }
          @if (pendencyForm.get('description')?.hasError('maxlength')) {
            <mat-error>
              {{
                'CREATE_OR_EDIT_PENDENCY_DIALOG.ERROR.MAX_LENGTH'
                  | translate: { maxLength: descriptionMaxLength, length: descriptionInput.value.length }
              }}
            </mat-error>
          }
        </mat-form-field>
      </div>

      <div class="flex flex-col gap-3">
        <span data-test-id="pendency-type-instructions" class="text-color-secondary text-sm mb-3">
          2. {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.PENDENCY.DESCRIPTION' | translate }}
        </span>

        <div class="w-full grid grid-cols-3 gap-3">
          <div>
            <app-fc-select-paged
              data-test-id="pendency-treatment-type-select"
              [service]="treatmentTypeService"
              [control]="pendencyForm.get('treatmentType')"
              [isRequired]="true"
              [placeholder]="'CREATE_OR_EDIT_PENDENCY_DIALOG.PENDENCY.TREATMENT_TYPE.LABEL' | translate"
            >
            </app-fc-select-paged>
          </div>

          <div>
            <app-fc-select-paged
              data-test-id="pendency-type-select"
              [service]="pendencyTypeService"
              [control]="pendencyForm.get('pendencyType')"
              [isRequired]="true"
              [placeholder]="'CREATE_OR_EDIT_PENDENCY_DIALOG.PENDENCY.PENDENCY_TYPE' | translate"
            >
            </app-fc-select-paged>
            <div class="h-5">
              @if (pendencyForm.get('pendencyType')?.hasError('required') && pendencyForm.get('pendencyType')?.dirty) {
                <mat-error>
                  {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.ERROR.REQUIRED' | translate }}
                </mat-error>
              }
            </div>
          </div>

          <div>
            <app-fc-select-multiple-paged
              class="w-full"
              [service]="usersService"
              [showImage]="true"
              [control]="pendencyForm.get('assignees')"
              [ignoredIds]="ignoredAssigneeIds()"
              [isRequired]="true"
              [placeholder]="'CREATE_OR_EDIT_PENDENCY_DIALOG.PENDENCY.ASSIGNEES' | translate"
            >
            </app-fc-select-multiple-paged>
            <div class="h-5">
              @if (pendencyForm.get('assignees')?.hasError('required') && pendencyForm.get('assignees')?.dirty) {
                <mat-error>
                  {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.ERROR.REQUIRED' | translate }}
                </mat-error>
              }
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col mb-3">
        <span data-test-id="pendency-company-instructions" class="text-color-secondary text-sm mb-6"
          >3. {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.COMPANY.DESCRIPTION' | translate }}</span
        >

        <div>
          <app-fc-select-paged
            [service]="companiesService"
            [showImage]="true"
            [control]="pendencyForm.get('company')"
            [isRequired]="$any(pendencyForm.get('treatmentType')?.value)?.id === 'external'"
            [placeholder]="'CREATE_OR_EDIT_PENDENCY_DIALOG.COMPANY.COMPANY' | translate"
            [fcTooltip]="'CREATE_OR_EDIT_PENDENCY_DIALOG.COMPANY.TOOLTIP_DISABLED' | translate"
            [fcTooltipDisabled]="!pendencyForm.get('company')?.disabled"
          >
          </app-fc-select-paged>
          <div class="h-5">
            @if (pendencyForm.get('company')?.hasError('required') && pendencyForm.get('company')?.dirty) {
              <mat-error>
                {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.ERROR.REQUIRED' | translate }}
              </mat-error>
            }
          </div>
        </div>

        <app-fc-maintenance-select
          class="w-full"
          data-test-id="pendency-maintenance"
          [companiesIds]="companiesIds()"
          [control]="pendencyForm.get('maintenance')"
          [placeholder]="'CREATE_OR_EDIT_PENDENCY_DIALOG.MAINTENANCE.LABEL' | translate"
          [fcTooltip]="'CREATE_OR_EDIT_PENDENCY_DIALOG.MAINTENANCE.TOOLTIP_DISABLED' | translate"
          [fcTooltipDisabled]="!pendencyForm.get('maintenance')?.disabled"
        ></app-fc-maintenance-select>
      </div>

      <div class="flex flex-col gap-6">
        <div class="flex items-center gap-1">
          <span data-test-id="pendency-readers-instructions" class="text-color-secondary text-sm">
            4. {{ 'CREATE_OR_EDIT_PENDENCY_DIALOG.READERS.DESCRIPTION' | translate }}
          </span>
          <mat-icon
            class="text-color-secondary mat-icon-sm cursor-help opacity-70"
            [matTooltip]="'CREATE_OR_EDIT_PENDENCY_DIALOG.READERS.TOOLTIP' | translate"
            >info_outline</mat-icon
          >
        </div>

        <app-fc-select-multiple-paged
          class="w-full"
          [service]="usersService"
          [showImage]="true"
          [control]="pendencyForm.get('readers')"
          [ignoredIds]="ignoredReaderIds()"
          [placeholder]="'CREATE_OR_EDIT_PENDENCY_DIALOG.READERS.READERS' | translate"
        >
        </app-fc-select-multiple-paged>
      </div>
    </form>
  </ng-scrollbar>

  @if (!isOnViewMode() && hasCanEditPermission) {
    <div class="flex items-center justify-between py-[10px] px-6 border-0 border-t border-t-color-light-shade border-solid">
      <button
        data-test-id="save-button"
        [ngClass]="{ 'cursor-default pointer-events-none opacity-50': isLoading() }"
        type="button"
        class="px-4 py-2 bg-color-primary rounded text-white font-['Roboto'] font-medium text-sm border-none h-10 cursor-pointer disabled:bg-color-secondary-disabled disabled:text-color-secondary disabled:cursor-auto"
        (click)="save()"
        [disabled]="!enableSaveButton()"
      >
        {{
          isOnEditDialog()
            ? ('CREATE_OR_EDIT_PENDENCY_DIALOG.BUTTON.SAVE' | translate)
            : ('CREATE_OR_EDIT_PENDENCY_DIALOG.BUTTON.CREATE' | translate)
        }}
      </button>
    </div>
  }
</div>
